import { AllActions } from "../actions";
import { StoreState } from "../types";
import * as constants from "../constants";

export function ui(state: StoreState.Ui, action: AllActions): StoreState.Ui {
  if (state === undefined) {
    state = {
      // filtersCollapsed: false,
      // filterPanelDetail: false,
      // filterPanelDetailSection: "",
      dataLoaded: false,
      requestInProgress: false,
      // fields: []
    };
  }

  switch (action.type) {
    // case constants.FILTER_DRILLDOWN:
    //   return {
    //     ...state,
    //     filterPanelDetail: true,
    //     filterPanelDetailSection: action.newFilterPanelDetailSection,
    //     fields: action.newFields
    //   };
    // case constants.FILTER_DRILLUP:
    //   return { ...state, filterPanelDetail: false, fields: [] };
    // case constants.FILTERS_COLLAPSED:
    //   return { ...state, filtersCollapsed: true };
    // case constants.FILTERS_EXPANDED:
    //   return { ...state, filtersCollapsed: false };
    case constants.DATA_REQUESTED:
      return { ...state, dataLoaded: false };
    case constants.DATA_LOADED:
      return { ...state, dataLoaded: true, requestInProgress: false };
    case constants.REQUEST_IN_PROGRESS:
      return { ...state, requestInProgress: true };
  }
  return state;
}
